






































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { getOrderOptions } from "@/request/ticketClientRequest";
import { timeFormat, dateFormat, downloadFile } from "@/utils/index";
import { setPage } from "@/utils/request";
import { getRoleOptions } from "@/request/roleList";
@Component({
  name: "PersonalAttendance"
})
export default class PersonalAttendance extends Vue {
  @Provide() private orderOptions: any = []; // lee 工单分类下拉列表
  @Provide() private searchForm: any = {
    pickDate: "",
    startDate: "",
    endDate: "",
    userName: "",
    email: "",
    employeeID: "",
    userGroupIds: null
  }; // lee 搜索表单
  @Provide() private searchFormRules: any = {
    pickDate: [
      {
        type: "date",
        required: true,
        message: "pls choose time at least",
        trigger: "change"
      }
    ]
  };
  @Provide() private labelPosition: string = "right"; // // by Hour: 1  or by Day: 0;
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {},
    shortcuts: [
      {
        text: "Today",
        onClick(picker: any) {
          const start = new Date();
          const _starttime =
            start.getFullYear() +
            "-" +
            (start.getMonth() + 1) +
            "-" +
            start.getDate();
          start.setTime(new Date(_starttime).getTime());
          const end = new Date();
          end.setTime(end.getTime());
          console.log([start, end]);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Yesterday",
        onClick(picker: any) {
          const end = new Date();
          const _endtime =
            end.getFullYear() +
            "-" +
            (end.getMonth() + 1) +
            "-" +
            end.getDate();
          end.setTime(new Date(_endtime).getTime());
          const start = new Date();
          start.setTime(new Date(_endtime).getTime() - 24 * 60 * 60 * 1000);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "Last 7 days",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }
    ],
    start: "00:00",
    step: "00:10",
    end: "23: 50"
  };
  @Provide() private pickDate: any = ""; // 时间范围
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private resultData: any = [];
  @Provide() private resultDataPreDay: any = [];
  @Provide() private roleOptions: any = [];
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  // lee 升降序 1升2降
  // 20200819 有一个兆麟的傻子要求默认成2
  @Provide() private isByDay: boolean = false;
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private isExportFormActionDone: boolean = false;
  @Provide() private isSearchFormActionByDayDone: boolean = false;
  @Provide() private isExportFormActionByDayDone: boolean = false;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  private getRoleListAPI() {
    getRoleOptions({
      trackId: "",
      clientId: "",
      token: this.token
    })
      .then((res: any) => {
        console.log(res, "getRoleListApi");
        switch (res.status) {
          case "success":
            this.roleOptions = res.data;
            break;
          case "code":
            this.$router.push("./login");
            break;
          case "error":
            this.$message.error(res.message);
            break;
        }
      })
      .catch((err: any) => {
        if (err.code == 16) {
          this.$router.push("./login");
        }
        console.log(err);
      });
  }
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getRoleListAPI();
  }
  //  lee 获取工单分类下拉列表
  private async getOrderOptions() {
    let res: any = await getOrderOptions({
      token: this.token
    });
    console.log(res, "rrrrrrrr");
    switch (res.status) {
      case "success":
        this.orderOptions = res.data;
        break;
      case "code":
        this.$router.push("./login");
        break;
      case "error":
        this.$message.error(res.message);
        break;
    }
  }
  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    console.log(this.searchForm);
    // if((this.pickDate&&this.pickDate.length>0)&&(this.roleData&&this.roleData.id)&&(this.searchForm.userName || this.searchForm.email || this.searchForm.employeeID)){
    if (this.searchForm.pickDate && this.searchForm.pickDate.length > 0) {
      return true;
    } else {
      this.$message.error("pls choose Time at least!");
      return false;
    }
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.isByDay ? this.getExtenListByDay() : this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.isByDay ? this.getExtenListByDay() : this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.isByDay ? this.getExtenListByDay() : this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.isByDay ? this.getExtenListByDay() : this.getExtenList();
  }
  //  lee 搜索操作
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.pagerCount = 0;
      this.pageIndex = 1;
      this.isSearchFormActionDone = true;
      this.getExtenList();
      setTimeout(() => {
        this.isByDay = false;
      }, 4);
    }
  }
  private searchFormActionByDay() {
    if (this.testSearchForm()) {
      this.pagerCount = 0;
      this.pageIndex = 1;
      this.isSearchFormActionByDayDone = true;
      this.getExtenListByDay();
      setTimeout(() => {
        this.isByDay = true;
      }, 4);
    }
  }
  //  lee 导出操作
  private async exportFormAction() {
    this.isByDay = false;
    const { downloadPersonalAttendanceExcel }: any = await import(
      "@/request/listPersonalAttendance"
    );
    console.log(downloadPersonalAttendanceExcel, "import");
    let response = await downloadPersonalAttendanceExcel(
      this.dwGetExtenListFuc(),
      this
    );
    console.log(response, "getWorkerPerformance");
    this.isExportFormActionDone = response ? response.loading : false;
    if (response) {
      console.log(response, "exportFormAction");
      if (response.filechunk) {
        let bStr = atob(response.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/json"
        });
        downloadFile(blob, response.filename);
      }
    }
  }
  private async exportFormActionByDay() {
    this.isByDay = true;
    const { downloadPersonalAttendanceDetailExcel }: any = await import(
      "@/request/listPersonalAttendanceDetail"
    );
    console.log(downloadPersonalAttendanceDetailExcel, "import");
    let response = await downloadPersonalAttendanceDetailExcel(
      this.dwGetExtenListbyDayFuc(),
      this
    );
    console.log(response, "downloadPersonalAttendanceDetailExcel");
    this.isExportFormActionByDayDone = response ? response.loading : false;
    if (response) {
      console.log(response, "downloadPersonalAttendanceDetailExcel");
      if (response.filechunk) {
        let bStr = atob(response.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/json"
        });
        downloadFile(blob, response.filename);
      }
    }
  }
  // lee 获取列表
  private dwGetExtenListFuc() {
    interface Options {
      startDate?: string; // 查询的开始时间
      endDate?: string; // 查询的结束时间
      name?: string; // 查询的结束时间
      userGroupIds?: Array<number>; // 查询的结束时间
      email?: string;
      employeeID?: string;
      pageIndex: number;
      pageSize: number;
    }
    let _arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      startDate:
        this.searchForm.pickDate && this.searchForm.pickDate.length > 0
          ? dateFormat(this.searchForm.pickDate[0].getTime())
          : "",
      endDate:
        this.searchForm.pickDate && this.searchForm.pickDate.length > 0
          ? dateFormat(this.searchForm.pickDate[1].getTime())
          : "",
      userGroupIds:
        this.searchForm.userGroupIds && this.searchForm.userGroupIds.length > 0
          ? this.searchForm.userGroupIds
          : null,
      name: this.searchForm.userName ? this.searchForm.userName : "", // 查询的结束时间
      email: this.searchForm.email ? this.searchForm.email : "", // 查询的结束时间
      employeeID: this.searchForm.employeeID ? this.searchForm.employeeID : "" // 查询的结束时间
    } as Options;
    console.log(_arg, "getExlist");
    return _arg;
  }
  private dwGetExtenListbyDayFuc() {
    let _arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      userId: Number(this.userid),
      dateRange:
        this.searchForm.pickDate && this.searchForm.pickDate.length > 0
          ? dateFormat(this.searchForm.pickDate[0].getTime()) +
            " " +
            dateFormat(this.searchForm.pickDate[1].getTime())
          : "",
      userGroupIds:
        this.searchForm.userGroupIds && this.searchForm.userGroupIds.length > 0
          ? this.searchForm.userGroupIds
          : null,
      name: this.searchForm.userName ? this.searchForm.userName : "", // 查询的结束时间
      email: this.searchForm.email ? this.searchForm.email : "", // 查询的结束时间
      employeeID: this.searchForm.employeeID ? this.searchForm.employeeID : "" // 查询的结束时间
    };
    return _arg;
  }
  private async getExtenList() {
    const { listPersonalAttendance }: any = await import(
      "@/request/listPersonalAttendance"
    );
    console.log(listPersonalAttendance, "import");
    let res = await listPersonalAttendance(this.dwGetExtenListFuc(), this);
    console.log(res, "listPersonalAttendance");
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.personalattendancerowsList == "object"
          ? res.personalattendancerowsList
          : JSON.parse(res.personalattendancerowsList);
      // this.updatedTime = timeFormat(res.updatetime);
      if (_result) {
        // lee 接口数据通了，但是没有数据，暂时Mork一份
        // this.resultData = this.isMorked ? this.MorkResultData : _result;
        this.resultData = _result;
        console.log(this.resultData, "getExtenList");
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  private async getExtenListByDay() {
    const { listPersonalAttendanceDetail }: any = await import(
      "@/request/listPersonalAttendanceDetail"
    );
    console.log(listPersonalAttendanceDetail, "import");
    let res = await listPersonalAttendanceDetail(
      this.dwGetExtenListbyDayFuc(),
      this
    );
    console.log(res, "listPersonalAttendanceDetail");
    this.isSearchFormActionByDayDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.personalattendancedetailrowsList == "object"
          ? res.personalattendancedetailrowsList
          : JSON.parse(res.personalattendancedetailrowsList);
      // this.updatedTime = timeFormat(res.updatetime);
      if (_result) {
        // lee 接口数据通了，但是没有数据，暂时Mork一份
        // this.resultData = this.isMorked ? this.MorkResultData : _result;
        this.resultDataPreDay = _result;
        console.log(this.resultDataPreDay, "getExtenList");
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
